import enquire from 'enquire.js'
import key from 'keymaster'
import tippy from 'tippy.js'

import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'

Drupal.behaviors.AutryBlockSearch = {
  attach: function (context, settings) {
    const elements = once('AutryBlockSearch', '.block.autry-block-search')
    elements.forEach(block => {
      const trigger = block.querySelector('.search-toggle')
      const panel = block.querySelector('.form-panel')
      const tooltip = block.querySelector('form').cloneNode(true)

      key.filter = () => true

      /*
       * DESKTOP: trigger next to the utility menu toggles dropdown
       */

      // hide the tippy if focus is outside the tooltip
      const hideTippyOnFocusOut = e => {
        if (block.contains(e.relatedTarget)) return
        this.tip.hide()
      }

      // hide the tippy and return focus to the trigger
      const hideTippyOnESC = e => {
        this.tip.hide()
        trigger.focus()
      }

      // init tippy
      const makeTippy = () => {
        return tippy(trigger, {
          trigger: 'click',
          interactive: true,
          placement: 'bottom',
          theme: 'light',
          content: tooltip,
          onShow () {
            block.addEventListener('focusout', hideTippyOnFocusOut)
            key('esc', hideTippyOnESC)
          },
          onShown (instance) {
            instance.popper.querySelector('input[name="search"]').focus()
          },
          onHide () {
            key.unbind('esc')
            block.removeEventListener('focusout', hideTippyOnFocusOut)
          }
        })
      }

      enquire.register('screen and (min-width : 1240px)', {
        // deferSetup: true,
        // setup: () => {},
        match: () => {
          this.tip = makeTippy()
          trigger.setAttribute('aria-controls', this.tip.popper.id)
        },
        unmatch: () => {
          this.tip.destroy()
        }
      })

      /*
       * MOBILE: trigger next to mmenu toggle toggles panel below header
       */

      // toggle panel visibility when trigger clicked
      const togglePanel = () => {
        panel.classList.toggle('is-visible')
        trigger.setAttribute(
          'aria-expanded',
          panel.classList.contains('is-visible')
        )
        if (panel.classList.contains('is-visible')) {
          panel.querySelector('input[name="search"]').focus()
        }
      }

      // hide panel on ESC and return focus to trigger
      const hidePanelOnESC = () => {
        panel.classList.remove('is-visible')
        trigger.setAttribute('aria-expanded', false)
        trigger.focus()
      }

      // hide the panel if focus is outside the block
      const hidePanelOnFocusOut = e => {
        if (block.contains(e.relatedTarget)) return
        panel.classList.remove('is-visible')
      }

      enquire.register('screen and (max-width : 1239px)', {
        // deferSetup: true,
        // setup: () => {},
        match: () => {
          trigger.setAttribute('aria-controls', 'autry-block-search-form')
          trigger.setAttribute('aria-expanded', false)
          trigger.addEventListener('click', togglePanel)
          block.addEventListener('focusout', hidePanelOnFocusOut)
        },
        unmatch: () => {
          panel.classList.remove('is-visible')
          trigger.removeEventListener('click', togglePanel)
          key.unbind('esc')
        }
      })
    })
  }
}
